module.exports = __webpack_public_path__ + "static/media/sportAvatar__sfv.1c90948d.jpg";